import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { RepairQuotesHowItWorks } from './HowItWorks/RepairQuotesHowItWorks/RepairQuotesHowItWorks';
import { SalvageRecordsHowItWorks } from './HowItWorks/SalvageRecordsHowItWorks/SalvageRecordsHowItWorks';
import { TitleBrandsHowItWorks } from './HowItWorks/TitleBrandsHowItWorks/TitleBrandsHowItWorks';
import { TitleRecordsHowItWorks } from './HowItWorks/TitleRecordsHowItWorks/TitleRecordsHowItWorks';
import { SerializedVehicleReport } from '../types/serialized';
import { AutomobileSalvage } from '../types/vehicles';

export const getHowItWorksContent = (sectionName: string) => {
  const howItWorksContent =
    sectionName.charAt(0).toLowerCase() +
    sectionName.replace(/\s+/g, '').slice(1);

  const howItWorksTitleMap: Record<string, JSX.Element> = {
    titleBrands: <HowItWorksCTA content={<TitleBrandsHowItWorks />} />,
    titleRecords: <HowItWorksCTA content={<TitleRecordsHowItWorks />} />,
    salvageRecords: <HowItWorksCTA content={<SalvageRecordsHowItWorks />} />,
    repairQuotes: <HowItWorksCTA content={<RepairQuotesHowItWorks />} />,
  };

  return howItWorksTitleMap[howItWorksContent];
};

export const getPremiumRecordsFound = (reportData: SerializedVehicleReport) => {
  const premiumRecordsFound = [];
  Boolean(reportData.automobiles[0]?.titleRecordsCount) &&
    premiumRecordsFound.push('Title Records');
  Boolean(reportData.automobiles[0]?.titleChecksCount) &&
    premiumRecordsFound.push('Title Brands');
  reportData.automobiles[0]?.salvage.some(
    (salvage: AutomobileSalvage) => salvage.premium
  ) && premiumRecordsFound.push('Salvage Records');

  return premiumRecordsFound;
};
